// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Bf4w","disabled":"FileBtn_disabled__1OfQC","warn":"FileBtn_warn__1sV7f","fade":"FileBtn_fade__3oJHT"};